export function localizeLanguage(language: 'fr' | 'en') {
    return language === 'fr' ? 'French' : 'English';
}

export function localizeLanguageShort(language: 'fr' | 'en') {
    return language === 'fr' ? 'Fr.' : 'Eng.';
}
